import React,{Component} from 'react';

import Wrapper from '../Wrapper';

import './Preorder.less';

const Preorder = ({res,id,data}) => {

  const link = data.social.filter(el => el.network == 'merchcowboy');

  return (
    <Wrapper title="Album bestellen" linkText="Offizieller Onlineshop" linkUrl={'https://theprosecution.merchcowboy.com/the-unfollowing'} res={res} id={id}>
    <div className={`preorder-wrapper ${res}`}>
    <a href="https://theprosecution.merchcowboy.com/the-unfollowing"><img src="https://the-prosecution.com/img/cover.jpg" alt="The Prosecution - The Unfollowing" style={{maxWidth:'100%'}} /></a>
    <div className="vorbestellen">

      <p>Erhältlich als Vinyl im Gatefold, CD, Tape und Digital.</p>

         <ul id="shoplinks">
         <li><a href="https://theprosecution.merchcowboy.com/the-unfollowing" target="_blank">Offizieller Onlineshop</a></li>&nbsp;
         <li><a href="https://www.longbeachrecords.de/product-category/long-beach-records-europe/the-prosecution/" target="_blank">Long Beach Webshop</a></li>&nbsp;
         <li><a href="http://bit.ly/prosec-wherewebelong" target="_blank">Spotify</a></li>&nbsp;
         <li><a href="http://amzn.to/2quFhdA" target="_blank">Amazon</a></li>&nbsp;
         <li><a href="http://bit.ly/prosec_wherewebelong" target="_blank">Apple Music</a></li>&nbsp;
         <li><a href="http://bit.ly/prosec-wherwe-amaz" target="_blank">Amazon Music</a></li>&nbsp;
         <li><a href="http://bit.ly/prosec-wherewe-google" target="_blank">Google Play</a></li>
         </ul>


        </div>
        </div>
    </Wrapper>
  )
}

export default Preorder



// WEBPACK FOOTER //
// ./src/components/sections/Preorder.js